interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  action?: { label: string; href: string };
}

export default function SectionHeading({ eyebrow, title, desc, action }: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 border-b border-background-200/80 pb-5 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <span className="flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600">
          <span className="h-px w-6 bg-primary-500"></span>
          {eyebrow}
        </span>
        <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {desc && <p className="mt-2 text-sm leading-relaxed text-foreground-600">{desc}</p>}
      </div>
      {action && (
        <a
          href={action.href}
          className="inline-flex shrink-0 items-center gap-1 text-sm text-foreground-700 transition-colors hover:text-primary-600 cursor-pointer"
        >
          {action.label}
          <i className="ri-arrow-right-line"></i>
        </a>
      )}
    </div>
  );
}